// extracted by mini-css-extract-plugin
export var errorsContainer = "_td-1";
export var link = "_td-0";